import { MoodResponseProps } from '@/types/moodsProps'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface MoodsProps {
  moods: MoodResponseProps[]
}

const initialState: MoodsProps = {
  moods: [],
}

const moodsSlice = createSlice({
  name: 'moods',
  initialState,
  reducers: {
    handleSetMoods(state, action: PayloadAction<MoodsProps>) {
      state.moods = action.payload.moods
    },
  },
})

export const { handleSetMoods } = moodsSlice.actions

export default moodsSlice.reducer
